import { render, staticRenderFns } from "./TaskPerformanceAreaMailsModalComponent.vue?vue&type=template&id=33c531ea&scoped=true"
import script from "./TaskPerformanceAreaMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./TaskPerformanceAreaMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskPerformanceAreaMailsModalComponent.vue?vue&type=style&index=0&id=33c531ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c531ea",
  null
  
)

export default component.exports